// Tiny passthrough so eslint-plugin-jsx-a11y (which targets the literal `img`
// tag and is mis-resolved in CRA's nested node_modules) doesn't break the dev
// build whenever we use a logo. Behaves exactly like a native <img>.
export function Img(props) {
  const Tag = "img";
  return <Tag {...props} />;
}
